import { Injectable } from '@angular/core';
import { generateClient } from 'aws-amplify/api';
import * as queries from '@graphql/queries';
import * as mutations from '@graphql/mutations';
import {
    OrderProcess,
    CreateOrderProcessInput,
    UpdateOrderProcessInput,
    ModelOrderProcessFilterInput,
    ModelSortDirection,
    DeleteOrderProcessInput
} from '@app/core/services/api/API.service';

@Injectable({
    providedIn: 'root'
})
export class OrderProcessService {
    private amplifyClient = generateClient();

    constructor() {}

    async getPremiumOrderProcess(id: string): Promise<OrderProcess> {
        try {
            const data: OrderProcess = (
                await this.amplifyClient.graphql({
                    query: queries.getOrderProcess,
                    variables: {
                        id
                    }
                })
            ).data.getOrderProcess as OrderProcess;
            if (data) return data;
        } catch (error) {
            console.error('Error finding user:', error);
            return null;
        }
    }

    async listPremiumOrderProcesses(): Promise<OrderProcess[]> {
        try {
            const data: OrderProcess[] = (
                await this.amplifyClient.graphql({
                    query: queries.listOrderProcesses
                })
            ).data.listOrderProcesses.items as OrderProcess[];
            if (data) return data;
        } catch (error) {
            console.error('Error finding user:', error);
            return null;
        }
    }
    async premiumProcessByClient(
        clientId: string,
        filter: ModelOrderProcessFilterInput = null,
        sortDirection: ModelSortDirection = ModelSortDirection.ASC
    ): Promise<OrderProcess[]> {
        try {
            const data = (
                await this.amplifyClient.graphql({
                    query: queries.OrderProcessByClient,
                    variables: {
                        clientId,
                        filter,
                        sortDirection
                    }
                })
            ).data.OrderProcessByClient.items;
            if (data) return data as OrderProcess[];
        } catch (error) {
            console.error('Error product:', error);
            return null;
        }
    }

    async createPremiumOrderProcess(
        input: CreateOrderProcessInput
    ): Promise<OrderProcess> {
        try {
            const data: OrderProcess = (
                await this.amplifyClient.graphql({
                    query: mutations.createOrderProcess,
                    variables: {
                        input
                    }
                })
            ).data.createOrderProcess as OrderProcess;
            if (data) return data;
        } catch (error) {
            console.error('Error creating process:', error);
            return null;
        }
    }

    async updatePremiumOrderProcess(
        input: UpdateOrderProcessInput
    ): Promise<OrderProcess> {
        try {
            const data: OrderProcess = (
                await this.amplifyClient.graphql({
                    query: mutations.updateOrderProcess,
                    variables: {
                        input
                    }
                })
            ).data.updateOrderProcess as OrderProcess;
            if (data) return data;
        } catch (error) {
            console.error('Error updating process:', error);
            return null;
        }
    }

    async createPopOrderProcess(
        input: CreateOrderProcessInput
    ): Promise<OrderProcess> {
        return this.createPremiumOrderProcess(input);
    }

    async updatePopOrderProcess(
        input: UpdateOrderProcessInput
    ): Promise<OrderProcess> {
        return this.updatePremiumOrderProcess(input);
    }

    async createPrintedOrderProcess(
        input: CreateOrderProcessInput
    ): Promise<OrderProcess> {
        return this.createPremiumOrderProcess(input);
    }

    async updatePrintedOrderProcess(
        input: UpdateOrderProcessInput
    ): Promise<OrderProcess> {
        return this.updatePremiumOrderProcess(input);
    }

    async deletePremiumOrderProcess(
        input: DeleteOrderProcessInput
    ): Promise<OrderProcess> {
        try {
            const data: OrderProcess = (
                await this.amplifyClient.graphql({
                    query: mutations.deleteOrderProcess,
                    variables: {
                        input
                    }
                })
            ).data.deleteOrderProcess as OrderProcess;
            if (data) return data;
        } catch (error) {
            console.error('Error deleting process:', error);
            return null;
        }
    }
}
